
document.addEventListener("DOMContentLoaded", function () {
  const carousel = document.getElementById('carousel03');
  const thumbnails = carousel.querySelectorAll("a[data-thumbnail-id]");
  const featuredImages = document.querySelectorAll(".product_image_featured");
  let currentIndex = 0;

  // Wrap carousel
  const wrapper = document.createElement('div');
  wrapper.classList.add('thumbnail-carousel-wrapper');
  carousel.parentNode.insertBefore(wrapper, carousel);
  wrapper.appendChild(carousel);

  // Add arrows
  const upArrow = document.createElement('div');
  upArrow.className = 'thumbnail-arrow up';
  upArrow.innerHTML = '&#10094;;';

  const downArrow = document.createElement('div');
  downArrow.className = 'thumbnail-arrow down';
  downArrow.innerHTML = '&#10095;';

  const leftArrow = document.createElement('div');
  leftArrow.className = 'thumbnail-arrow left';
  leftArrow.innerHTML = '&#10094;';

  const rightArrow = document.createElement('div');
  rightArrow.className = 'thumbnail-arrow right';
  rightArrow.innerHTML = '&#10095;';

  wrapper.appendChild(upArrow);
  wrapper.appendChild(downArrow);
  wrapper.appendChild(leftArrow);
  wrapper.appendChild(rightArrow);

  const THUMB_SIZE = 130; // Adjust based on actual thumbnail + margin
  const VISIBLE_COUNT = 3;

  function updateFeaturedImage(index) {
    featuredImages.forEach((img, i) => {
      img.classList.toggle("hide", i !== index);
    });

    thumbnails.forEach((thumb, i) => {
      thumb.classList.toggle("active", i === index);
    });

    currentIndex = index;
    scrollToThumb(index);
  }

  function scrollToThumb(index) {
    const isMobile = window.innerWidth <= 768;
    const offset = -index * THUMB_SIZE;
    carousel.style.transform = isMobile
      ? `translateX(${offset}px)`
      : `translateY(${offset}px)`;
  }

  function handleArrow(direction) {
    const max = thumbnails.length - 1;
    if (direction === 'next' && currentIndex < max) {
      updateFeaturedImage(currentIndex + 1);
    }
    if (direction === 'prev' && currentIndex > 0) {
      updateFeaturedImage(currentIndex - 1);
    }
  }

  upArrow.addEventListener('click', () => handleArrow('prev'));
  downArrow.addEventListener('click', () => handleArrow('next'));
  leftArrow.addEventListener('click', () => handleArrow('prev'));
  rightArrow.addEventListener('click', () => handleArrow('next'));

  // Allow clicking thumbs to change image
  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener("click", (e) => {
      e.preventDefault();
      updateFeaturedImage(index);
    });
  });

  window.addEventListener("resize", () => {
    scrollToThumb(currentIndex);
  });

  // Init on load
  updateFeaturedImage(0);
});

